import { render, staticRenderFns } from "./uiCheck.vue?vue&type=template&id=24417e4c"
import script from "./uiCheck.vue?vue&type=script&lang=js"
export * from "./uiCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports